import { Routes } from '@angular/router'
import { Login } from '@core/authentication/auth/login'
import { Callback } from '@core/authentication/auth/callback'
import { authGuard } from '@core/guards/auth.guard'
import { roleGuard } from '@core/guards/role.guard'
import { AuthPage } from '@core/authentication/auth/auth.enums'
import { Logout } from '@core/authentication/auth/logout'
import { ErrorPage } from '@core/error/components/error-page/error-page'
import { MarketableService } from '@features/marketable/marketable.service'
import { marketableResolver } from '@features/marketable/marketable.resolvers'
import { PermissionsStore } from '@features/permissions/store/permissions.store'
import { provideState } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'
import { LicenseService } from '@features/license/license.service'
import { StadiumService } from '@features/stadium/stadium.service'
import { PlayersManagerApi } from '@features/players-manager/players-manager.api'
import { PlayersManagerStore } from '@features/players-manager/store/players-manager.store'
import { STADIUMS_FEATURE_TOKEN } from '@features/stadiums/stadium.tokens'
import { stadiumsReducer } from '@features/stadiums/store/reducers/stadiums.reducer'
import { StadiumsEffects } from '@features/stadiums/store/effects/stadiums.effects'
import { stadiumsResolver } from '@features/stadiums/stadiums.resolver'

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: Login },
  { path: 'auth', component: Callback },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [roleGuard],
    children: [
      {
        path: AuthPage.Playground,
        loadComponent: () => import('./features/playground/playground').then((m) => m.Playground),
      },
      {
        path: AuthPage.Administration,
        loadComponent: () => import('./features/bo-users/usersBO').then((m) => m.UsersBO),
      },
      {
        path: AuthPage.UserCustomerView,
        loadComponent: () =>
          import('./features/user-customers/user-customer-view').then((m) => m.UserCustomerView),
      },
      {
        path: AuthPage.Marketable,
        providers: [MarketableService, PermissionsStore],
        resolve: { data: marketableResolver },
        loadComponent: () => import('./features/marketable/marketable').then((m) => m.Marketable),
      },
      {
        path: AuthPage.DataIncoming,
        loadComponent: () =>
          import('./features/data-incoming/data-incoming').then((m) => m.DataIncoming),
      },
      {
        path: AuthPage.DataPublishing,
        loadComponent: () =>
          import('./features/data-publishing/data-publishing').then((m) => m.DataPublishing),
      },
      {
        path: AuthPage.Stadium,
        providers: [StadiumService],
        loadComponent: () => import('./features/stadium/stadium').then((m) => m.Stadium),
      },
      {
        path: AuthPage.Stadiums,
        providers: [
          provideState(STADIUMS_FEATURE_TOKEN, stadiumsReducer),
          provideEffects(StadiumsEffects),
        ],
        resolve: { data: stadiumsResolver },
        loadComponent: () =>
          import('./features/stadiums/stadiums-container').then((m) => m.StadiumsContainer),
      },
      {
        path: AuthPage.License,
        providers: [LicenseService],
        loadComponent: () => import('./features/license/license').then((m) => m.License),
      },
      {
        path: AuthPage.MediaReports,
        loadComponent: () =>
          import('./features/media-reports/media-reports').then((m) => m.MediaReports),
      },
      {
        path: AuthPage.PermissionManagement,
        loadComponent: () =>
          import('./features/permission-management/permission-management').then(
            (m) => m.PermissionManagement,
          ),
      },
      {
        path: AuthPage.PlayersManager,
        providers: [PlayersManagerApi, PlayersManagerStore],
        loadComponent: () =>
          import('./features/players-manager/players-manager-container').then(
            (m) => m.PlayersManagerContainer,
          ),
      },
      { path: AuthPage.NotPermitted, component: ErrorPage },
    ],
  },
  { path: 'logout', component: Logout },
  { path: '**', component: ErrorPage },
]
